import React, { Fragment } from "react";
import { Button } from "@mui/material";
import { ReactComponent as EditIcon } from "assets/edit.svg";
import { ReactComponent as TrashIcon } from "assets/trash.svg";
import RepeatIcon from "@mui/icons-material/Repeat";
import { useDispatch, useSelector } from "react-redux";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import {
  addProceedBool,
  addUploadMediaIds,
  addUploads,
  getSelectedGroupProducts,
  getUploadMediaIds,
  mobSelected,
} from "features/product/productSlice";
import { addReturnedProducts } from "features/returnedProducts/returnedProductSlice";
import { updateWebSelected } from "features/orders/orderSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";

function CartProducts({
  cart_type,
  product,
  location,
  returnedProducts,
  outOfStock,
}) {
  const merchantConfig = useSelector(getMerchantConfig);
  const rmsConfig = useSelector(getRmsConfig);
  const selectedGroupProducts = useSelector(getSelectedGroupProducts);
  const uploadedMediaIds = useSelector(getUploadMediaIds);
  const isExchangeFulfillmentItem =
    product.return_type === "exchange" || product.return_type === "replacement";

  const dispatch = useDispatch();

  const removeReturnedItem = (line_item_id) => {
    const line_item_ids = returnedProducts.map((a) => a.line_item_id);
    const tempProducts = [...returnedProducts];
    const updatedMediaIds = uploadedMediaIds.filter(
      (mediaId) => mediaId.line_item_id !== line_item_id
    );

    if (selectedGroupProducts.length > 0) {
      for (let i = selectedGroupProducts.length - 1; i >= 0; i--) {
        const product = selectedGroupProducts[i];

        const index = line_item_ids.indexOf(product.line_item_id);

        if (index !== -1) {
          tempProducts.splice(index, 1);
          line_item_ids.splice(index, 1);
        }
      }
    } else {
      const index = line_item_ids.indexOf(line_item_id);
      tempProducts.splice(index, 1);
    }

    dispatch(addUploadMediaIds(updatedMediaIds));
    dispatch(addUploads([]));
    dispatch(addReturnedProducts([...tempProducts]));
  };

  const handleEdit = () => {
    dispatch(addProceedBool(false));
    if (window.innerWidth < 800) {
      dispatch(mobSelected(true));
    } else {
      dispatch(updateWebSelected(true));
    }
  };

  return (
    <div
      className="cart-wrapper"
      style={{
        background:
          cart_type === "yet_to_create"
            ? merchantConfig.merchant_id === 977 ? "#F5F8FF" :
            `${merchantConfig.primary_theme_color}22`
            : cart_type === "accepted"
            ? "#DEF8E4"
            : cart_type === "rejected"
            ? "#F9C8C8"
            : cart_type === "pending"
            ? "#99999933"
            : cart_type === "shipment"
            ? "transparent"
            : `${merchantConfig.primary_theme_color}22`,
        border:
          cart_type === "yet_to_create"
            ? `none`
            : cart_type === "accepted"
            ? "1px solid #24A843"
            : cart_type === "rejected"
            ? "1px solid #b81414"
            : cart_type === "pending"
            ? "1px solid #444"
            : cart_type === "shipment"
            ? "none"
            : `none`,
        borderRadius:
          cart_type === "yet_to_create"
            ? "0"
            : merchantConfig.use_rounded_edge_buttons
            ? "10px"
            : "0px",
        padding: "1rem",
      }}
    >
      <div className="exchange-wrapper">
        <div className="exchange-box return-item-box">
          <p
            className="return-label"
            style={{
              display: cart_type === "yet_to_create" ? "none" : "block",
              background:
                cart_type === "yet_to_create"
                  ? `${merchantConfig.primary_theme_color}`
                  : cart_type === "accepted"
                  ? product.qc_performed_at
                    ? product.qc_passed
                      ? "#24A843"
                      : "#b81414"
                    : "#24A843"
                  : cart_type === "rejected"
                  ? "#b81414"
                  : cart_type === "pending"
                  ? "#444"
                  : cart_type === "shipment"
                  ? `${merchantConfig.primary_theme_color}`
                  : `${merchantConfig.primary_theme_color}`,
            }}
          >
            {isExchangeFulfillmentItem
              ? rmsConfig.only_replacement || product.return_type === "replacement"
                ? "Replacement"
                : "Exchange"
              : "Return"}
            {product.qc_performed_at &&
              ` - ${product.qc_passed ? "QC Passed" : "QC Failed"} `}
          </p>
          <div className="image-preview-container">
            <LazyLoadImage
              effect="opacity"
              className="image-preview"
              src={product.variant_image_url}
              alt={product.product_title}
            />
          </div>
          <div className="details">
            <p className="title" style={{color: merchantConfig.primary_theme_color}}>{product.product_title}</p>
            <p className="description">
              {product.variant_name !== null &&
              product.variant_name.indexOf("Default") === -1
                ? product.variant_name
                : product.product_title}
            </p>
            <p className="quantity">Quantity: {product.quantity}</p>
            <p className="price">
              {product.total_item_discount > 0 ? (
                <span>
                  ₹ {product.discounted_price}{" "}
                  <span
                    style={{
                      textDecoration: "line-through",
                      fontSize: "14px",
                      marginLeft: "4px",
                    }}
                  >
                    ₹{product.original_product_price}
                  </span>
                </span>
              ) : (
                `₹ ${product.product_price}`
              )}
            </p>
          </div>
        </div>

        {isExchangeFulfillmentItem && (
          <Fragment>
            <div style={{ position: "relative", marginTop: "1rem" }}>
              <hr
                style={{
                  border: 0,
                  borderTop:
                    cart_type === "yet_to_create"
                      ? `1px solid ${merchantConfig.primary_theme_color}`
                      : cart_type === "accepted"
                      ? "1px solid #24A843"
                      : cart_type === "rejected"
                      ? "1px solid #b81414"
                      : cart_type === "pending"
                      ? "1px solid #444"
                      : cart_type === "shipment"
                      ? "0"
                      : "none",
                }}
                className="mob-ex-divider"
              />
              <div className="return-icon">
                <RepeatIcon
                  style={{
                    color: "#fff",
                    background:
                      cart_type === "yet_to_create"
                        ? `${merchantConfig.primary_theme_color}`
                        : cart_type === "accepted"
                        ? "#24A843"
                        : cart_type === "rejected"
                        ? "#b81414"
                        : cart_type === "pending"
                        ? "#444"
                        : cart_type === "shipment"
                        ? `${merchantConfig.primary_theme_color}`
                        : `${merchantConfig.primary_theme_color}`,
                    borderRadius: "50%",
                    padding: "8px",
                    fontSize: "30px",
                  }}
                />
              </div>
            </div>
            <div className="exchange-box">
              <div className="image-preview-container">
                <LazyLoadImage
                  effect="opacity"
                  className="image-preview"
                  src={product.exchange_variant_image_url}
                  alt={product.exchange_product_title}
                />
              </div>
              <div className="details">
                {outOfStock !== undefined && outOfStock !== null && (
                  <p className="stock">Out of Stock</p>
                )}
                <p className="title" style={{color: merchantConfig.primary_theme_color}}>{product.exchange_product_title}</p>
                <p className="description">
                  {product.variant_name !== null &&
                  product.variant_name.indexOf("Default") === -1
                    ? product.exchange_variant_name
                    : product.exchange_product_title}
                </p>

                {merchantConfig.merchant_id === 977 &&
                  product.properties &&
                  product.properties.length > 0 && (
                    <p style={{ fontSize: "14px", color: "#3B444D" }}>
                      {product.properties.map((prop, index) => (
                        <p key={index} style={{ marginTop: "6px" }}>
                          {prop.name}: {prop.value}
                        </p>
                      ))}
                    </p>
                  )}
                <p className="quantity">Quantity: {product.quantity}</p>

                {((product.variant_id !== product.exchange_variant_id &&
                  product.exchange_type == "different") ||
                  merchantConfig.merchant_id == 977) && (
                  <p className="price">
                    {rmsConfig.discount_config &&
                      Object.keys(rmsConfig.discount_config).length > 0 &&
                      rmsConfig.discount_config.target_type === "line_item" && (
                        <span>
                          ₹{" "}
                          {rmsConfig.discount_config.type === "fixed"
                            ? product.exchange_product_price -
                              rmsConfig.discount_config.value
                            : (
                                product.exchange_product_price -
                                (product.exchange_product_price *
                                  rmsConfig.discount_config.value) /
                                  100
                              ).toFixed(2)}
                        </span>
                      )}
                    <span
                      style={{
                        textDecoration:
                          rmsConfig.discount_config &&
                          Object.keys(rmsConfig.discount_config).length > 0
                            ? "line-through"
                            : "none",
                        marginLeft:
                          rmsConfig.discount_config &&
                          Object.keys(rmsConfig.discount_config).length > 0
                            ? "10px"
                            : "0px",
                        color: "#3B444D"
                      }}
                    >
                      ₹ {product.exchange_product_price}
                    </span>
                  </p>
                )}
              </div>
            </div>
          </Fragment>
        )}
      </div>

      {/* {product.return_type && location==="/tracking" && <p style={{color: '#3B444D'}} className='return-type'>Return Type : <span style={{textTransform: 'capitalize',color: '#3B444DB2'}}> {product.return_type}</span></p>} */}
      {product.customer_reason_label && (
        <p
          style={{ color: "#3B444D", margin: "10px 0px" }}
          className="return-reason"
        >
          Reason:
          <span>
            {" "}
            {product.customer_reason_label}
            {product.customer_sub_reason_label &&
              ` / ${product.customer_sub_reason_label}`}
          </span>
        </p>
      )}

      {(location === "/return-cart" || location === "/products") && (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* <p style={{fontSize: '12px', textDecoration: 'underline', color: '#111111'}}>View Price Details</p> */}
          {/* <Button
            color="primary"
            onClick={() => handleEdit()}
            style={{ textTransform: "capitalize" }}
            startIcon={
              <EditIcon
                style={{ stroke: merchantConfig.primary_theme_color }}
              />
            }
          >
            {" "}
            Edit{" "}
          </Button> */}
          <Button
            color="primary"
            onClick={() => removeReturnedItem(product.line_item_id)}
            startIcon={
              <TrashIcon
                style={{ stroke: merchantConfig.primary_theme_color }}
              />
            }
            style={{ paddingLeft: "0", fontWeight: 700 }}
            sx={{
              "& .MuiButton-startIcon": {
                marginRight: "2px",
                marginLeft: "0px",
              },
            }}
          >
            <span style={{ marginTop: "4px" }}>Remove</span>
          </Button>
        </div>
      )}
    </div>
  );
}

export default CartProducts;
